import { getRequest, formRequest, patchRequest, deleteRequest } from "@react/helpers/fetch"

export const fetchLibrary = (baseUrl) => getRequest(`${baseUrl}.json`)

export const uploadDocument = (baseUrl, file, { name, category, description } = {}) => {
  const form = new FormData()
  form.append("file", file)
  if (name)        form.append("name",        name)
  if (category)    form.append("category",    category)
  if (description) form.append("description", description)
  return formRequest({ method: "POST", url: `${baseUrl}.json`, form })
}

export const updateDocument = (baseUrl, id, body) =>
  patchRequest({ url: `${baseUrl}/${id}.json`, body })

export const destroyDocument = (baseUrl, id) =>
  deleteRequest(`${baseUrl}/${id}.json`)
